export function getTestID(testID: string) {
  // this was originally used to prefix the android test id with 'com.citypass.my:id/'
  // think we though that was going to be necessary for test automation.  as we have
  // implemented testing it doesn't look like it is so removing that and returning the
  // test id.  We can refactor this out completely later if we are comfortanl
  if (!testID) {
    return '';
  }
  return testID;
}

export const tID = getTestID;
